// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__H1qMe","content":"RecentSearches_content__v5saP"};